import { AWSUser } from "@archetypes/auth";
import { getUser } from "@utils/auth.util";
import { useEffect, useState } from "react";

const useUser = () => {
  const [user, setUser] = useState<AWSUser>();
  const [loading, setLoading] = useState<boolean>(true);
  useEffect(() => {
    async function fetchUserDetails() {
      const user = await getUser();
      setUser(user);
      setLoading(false);
    }
    setLoading(true);
    fetchUserDetails();
  }, []);

  return { user, loading };
};

export default useUser;
